import FormValidations from "../FormValidations";
import {SimpleInputValidator} from "./SimpleInputValidator";

export class TextInputValidator implements SimpleInputValidator {
    isValid(value: string, required: boolean): boolean {
        return required
            ? FormValidations.isNotEmpty(value)
            : true;
    }
}